export default __webpack_public_path__ + "static/media/transaction_gold.1d639b70.svg";